import React from 'react';
import { Modal } from 'react-bootstrap';
import './VideoModal.css';

const VideoModal = ({ show, onHide, videoSrc = 'dQw4w9WgXcQ' }) => {
  const isYouTube = !videoSrc.includes('.') && videoSrc.length > 5; // Simple check for YouTube ID

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      className="video-modal"
      backdropClassName="video-modal-backdrop"
    >
      <Modal.Body className="video-modal-body">
        <button className="video-modal-close" onClick={onHide}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <div className="video-container">
          {isYouTube ? (
            <iframe
              src={`https://www.youtube.com/embed/${videoSrc}?autoplay=1`}
              title="How It Works"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <video
              src={videoSrc}
              controls
              autoPlay
              className="w-100"
              style={{ maxHeight: '80vh' }}
            >
              Your browser does not support the video tag.
            </video>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VideoModal;
